
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ChartContainer',
  props: {
    chartPresent: {
      type: Boolean,
      default: true
    },
    isWidget: {
      type: Boolean,
      default: false
    }
  }
})
